import React from 'react';
import QuestionCircleIcon from '@atlaskit/icon/core/migration/question-circle';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { createWorkVideoEducationModalEntryPoint } from '@atlassian/jira-create-work-video-education-modal/entrypoint.tsx';

import { ModalEntryPointButtonTrigger } from '@atlassian/jira-modal-entry-point-button-trigger/src/ModalEntryPointButtonTrigger.tsx';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge/src/utils/fire-analytics.tsx';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

export const CreateWorkVideoEducationModalTriggerButton = () => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<Tooltip content={formatMessage(messages.tooltip)}>
			<ModalEntryPointButtonTrigger
				appearance="subtle"
				entryPoint={createWorkVideoEducationModalEntryPoint}
				entryPointProps={{}}
				interactionName="create-work-video-education-modal"
				useInternalModal
				modalProps={{
					width: 'x-large',
					onOpenComplete: () => {
						fireUIAnalytics(
							createAnalyticsEvent({
								action: 'open',
								actionSubject: 'modalDialog',
							}),
							'createWorkVideoEducationModal',
						);
					},
					onCloseComplete: () => {
						fireUIAnalytics(
							createAnalyticsEvent({
								action: 'close',
								actionSubject: 'modalDialog',
							}),
							'createWorkVideoEducationModal',
						);
					},
				}}
				onClick={() => {
					fireUIAnalytics(
						createAnalyticsEvent({
							action: 'clicked',
							actionSubject: 'button',
						}),
						'openCreateWorkVideoEducationModal',
					);
				}}
				testId="issue-create-commons.ui.create-work-video-education-modal-trigger-button.create-work-video-education-modal-trigger-button"
			>
				<QuestionCircleIcon label={formatMessage(messages.tooltip)} LEGACY_size="small" />
			</ModalEntryPointButtonTrigger>
		</Tooltip>
	);
};
